export enum SESSION_INFOBAR_TYPE {
  registeredAccount = 'registeredAccount',
}

export type LocationStateType = Record<SESSION_INFOBAR_TYPE, { email: string }>
